import { onUnmounted, ref, type Ref } from 'vue'

export const useTimer = (
  from: number,
): { count: Ref<number>; reset: () => void; clear: () => void } => {
  const intervalId = ref<NodeJS.Timeout | null>(null)
  const count = ref(from)

  const reset = (): void => {
    if (intervalId.value) {
      clearInterval(intervalId.value)
    }
    count.value = from

    intervalId.value = setInterval(() => {
      count.value--
      if (count.value <= 0 && intervalId.value !== null) {
        clearInterval(intervalId.value)
      }
    }, 1000)
  }

  onUnmounted(() => {
    if (intervalId.value !== null) {
      clearInterval(intervalId.value)
    }
  })

  const clear = (): void => {
    if (intervalId.value !== null) {
      clearInterval(intervalId.value)
    }
  }

  return { count, reset, clear }
}
